"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RetailerProductEdition = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _styles = require("./styles");

var _HeaderTop = require("../../molecules/HeaderTop");

var _ImagePreviewer = require("../../organisms/ImagePreviewer");

var _ImageDataTable = require("../../organisms/ImageDataTable");

var _FullProductNameHeader = require("../../organisms/FullProductNameHeader");

var _FullTabsMenu = require("../../organisms/FullTabsMenu");

var _InputGroup = require("../../organisms/InputGroup");

var _react = require("react");

var _GalleryElement = require("../../molecules/GalleryElement");

var _fileSaver = require("file-saver");

var _Commentary = require("../../atoms/Commentary");

var _data2 = require("../../../global-files/data");

var _GalleryHeader = require("../../molecules/GalleryHeader");

var _ProductImageModal = require("../../organisms/ProductImageModal");

var _reactDropzone = require("react-dropzone");

var _axios = _interopRequireDefault(require("axios"));

var _uuid = require("uuid");

var _awsSdk = _interopRequireDefault(require("aws-sdk"));

var _attributesSent = _interopRequireDefault(require("../../../assets/images/modalsSVGs/attributesSent.svg"));

var _descriptionSent = _interopRequireDefault(require("../../../assets/images/modalsSVGs/descriptionSent.svg"));

var _uploadingImages = _interopRequireDefault(require("../../../assets/images/modalsSVGs/uploadingImages.svg"));

var _index = require("../../molecules/TagAndInput/index");

var _GeneralButton = require("../../atoms/GeneralButton");

var _GenericModal = require("../../atoms/GenericModal");

var _ScreenHeader = require("../../atoms/ScreenHeader");

var _Loading = require("../../atoms/Loading");

var _genericModalCheck = _interopRequireDefault(require("../../../assets/images/genericModal/genericModalCheck.svg"));

var _VersionSelector = require("../../organisms/VersionSelector");

var _customHooks = require("../../../global-files/customHooks");

var _utils = require("./utils");

var _Modal = require("../../organisms/Modal");

var _ButtonV = require("../../atoms/ButtonV2");

var _generateThumnail = _interopRequireDefault(require("./generateThumnail"));

var _jsxRuntime = require("react/jsx-runtime");

var reducerImages = function reducerImages(state, action) {
  var _action$init, _action$init$inputsBy;

  var values = state.values,
      attrForImgs = state.attrForImgs,
      inputsByRetailer = state.inputsByRetailer;

  switch (action.action) {
    case "init":
      var newInputsByRetailer = {};
      action === null || action === void 0 ? void 0 : (_action$init = action.init) === null || _action$init === void 0 ? void 0 : (_action$init$inputsBy = _action$init.inputsByRetailer) === null || _action$init$inputsBy === void 0 ? void 0 : _action$init$inputsBy.forEach(function (inputs) {
        inputs === null || inputs === void 0 ? void 0 : inputs.forEach(function (input) {
          if (!newInputsByRetailer["".concat(input.id_retailer)]) newInputsByRetailer["".concat(input.id_retailer)] = [];
          newInputsByRetailer["".concat(input.id_retailer)].push(input);
        });
      });
      inputsByRetailer = newInputsByRetailer;
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, action.init), {}, {
        inputsByRetailer: inputsByRetailer,
        valuesInitial: action.init.values,
        inputsInitial: action.init.inputs
      });

    case "addImg":
      values = [].concat((0, _toConsumableArray2.default)(values), [action.img]);
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
        values: values
      });

    case "changeImageInfo":
      values[action.index][action.attribute] = action.value;
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
        values: values
      });

    case "changeShotType":
      values[action.index][action.attribute] = action.value;
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
        values: values
      });

    case "changeAttrValue":
      var index = attrForImgs.general.findIndex(function (f) {
        return f.id === action.id;
      });

      if (index !== -1) {
        attrForImgs.general[index].value = action.value;
      }

      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
        attrForImgs: attrForImgs,
        values: values
      });

    case "deleteImage":
      values = values.filter(function (value) {
        return action.selectedImages.indexOf(value) === -1;
      });
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
        values: values
      });

    case "orderImages":
      {
        var _inputsByRetailer = state.inputsByRetailer,
            valuesInitial = state.valuesInitial,
            inputsInitial = state.inputsInitial,
            inputs = state.inputs;

        try {
          var _inputsByRetailer$act;

          var orderedImages = [];
          var imageIdArray = [];

          if (action !== null && action !== void 0 && action.retailerId && !_inputsByRetailer[action.retailerId]) {
            _inputsByRetailer[action.retailerId] = [];
          }

          action.retailerId && ((_inputsByRetailer$act = _inputsByRetailer[action.retailerId]) === null || _inputsByRetailer$act === void 0 ? void 0 : _inputsByRetailer$act.filter(function (input) {
            imageIdArray.push(input.id_image);
            valuesInitial.forEach( /*#__PURE__*/function () {
              var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(value) {
                return _regenerator.default.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        if (value.ext == "mp4") {
                          convertirVideoABase64("https://" + process.env.REACT_APP_IMAGES_BUCKET + ".s3.amazonaws.com/" + value.srcDB).then( /*#__PURE__*/function () {
                            var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(base64) {
                              var videoSrc;
                              return _regenerator.default.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      videoSrc = "data:video/mp4;base64," + base64.split(",")[1]; // Añade el tipo MIME adecuado

                                      _context.next = 3;
                                      return (0, _generateThumnail.default)(videoSrc, 2);

                                    case 3:
                                      value.src = _context.sent;

                                    case 4:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee);
                            }));

                            return function (_x2) {
                              return _ref2.apply(this, arguments);
                            };
                          }()).catch(function (error) {
                            console.error("Error:", error);
                          });
                        }

                        if (value.image_id === input.id_image) orderedImages.push(value);

                      case 2:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x) {
                return _ref.apply(this, arguments);
              };
            }());
          }));
          inputs = inputsInitial === null || inputsInitial === void 0 ? void 0 : inputsInitial.filter(function (input) {
            return imageIdArray.includes(input.id);
          });
          values = orderedImages.length > 0 ? orderedImages : [];
        } catch (error) {
          console.log(error);
        }

        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
          values: values,
          inputs: inputs
        });
      }

    default:
      return state;
  }
};

var S3_BUCKET = process.env.REACT_APP_IMAGES_BUCKET;
var REGION = "us-east-1";

function convertirVideoABase64(url) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";

    xhr.onload = function () {
      if (xhr.status === 200) {
        var blob = xhr.response;
        var reader = new FileReader();

        reader.onloadend = function () {
          resolve(reader.result);
        };

        reader.readAsDataURL(blob);
      } else {
        reject(new Error("Error al cargar el video"));
      }
    };

    xhr.onerror = function () {
      reject(new Error("Error de red al cargar el video"));
    };

    xhr.send();
  });
}

function obtenerDuracionVideoBase64(base64Data) {
  return new Promise(function (resolve, reject) {
    var video = document.createElement("video");
    video.src = base64Data;
    video.addEventListener("loadedmetadata", function () {
      resolve(video.duration);
    });
    video.addEventListener("error", reject);
  });
}

_awsSdk.default.config.update({
  accessKeyId: process.env.REACT_APP_KUTS3,
  secretAccessKey: process.env.REACT_APP_AKUTS3
});

var myBucket = new _awsSdk.default.S3({
  params: {
    Bucket: S3_BUCKET
  },
  region: REGION
});

var RetailerProductEdition = function RetailerProductEdition(_ref3) {
  var _product$retailers, _location$state, _location$state2, _product$services2, _datasheets$, _datasheets$$data, _product$article18, _comment$message;

  var tabsSections = _ref3.tabsSections,
      _ref3$productSelected = _ref3.productSelected,
      productSelected = _ref3$productSelected === void 0 ? {} : _ref3$productSelected,
      _ref3$user = _ref3.user,
      user = _ref3$user === void 0 ? {} : _ref3$user,
      token = _ref3.token,
      location = _ref3.location;

  var _useState = (0, _react.useState)("Descripción"),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      activeImage = _useState4[0],
      setActiveImage = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      imageLayout = _useState6[0],
      setImageLayout = _useState6[1];

  var _useState7 = (0, _react.useState)(0),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      headerTop = _useState8[0],
      setHeaderTop = _useState8[1];

  var _useState9 = (0, _react.useState)([]),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      descriptions = _useState10[0],
      setDescriptions = _useState10[1];

  var _useState11 = (0, _react.useState)([]),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      datasheets = _useState12[0],
      setDatasheets = _useState12[1];

  var _useReducer = (0, _react.useReducer)(reducerImages, {}),
      _useReducer2 = (0, _slicedToArray2.default)(_useReducer, 2),
      images = _useReducer2[0],
      setImages = _useReducer2[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      showModal = _useState14[0],
      setShowModal = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
      showRejectModal = _useState16[0],
      setShowRejectModal = _useState16[1];

  var _useDropzone = (0, _reactDropzone.useDropzone)({
    accept: "image/*, video/mp4",
    noKeyboard: true,
    multiple: true,
    noClick: true,
    onDrop: function onDrop(acceptedFiles) {
      var newImages = [];
      acceptedFiles.map(function (file) {
        var reader = new FileReader();
        reader.fileName = file.name;

        reader.onload = /*#__PURE__*/function () {
          var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(e) {
            var ext, img;
            return _regenerator.default.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    ext = e.srcElement.fileName.split(".");
                    img = new Image();

                    if (ext[ext.length - 1] == "mp4") {
                      obtenerDuracionVideoBase64(e.target.result).then( /*#__PURE__*/function () {
                        var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(duracion) {
                          return _regenerator.default.wrap(function _callee3$(_context3) {
                            while (1) {
                              switch (_context3.prev = _context3.next) {
                                case 0:
                                  if (!(duracion > 15 && duracion < 600)) {
                                    _context3.next = 7;
                                    break;
                                  }

                                  _context3.next = 3;
                                  return (0, _generateThumnail.default)(e.target.result, 2);

                                case 3:
                                  img.src = _context3.sent;
                                  setTimeout(function () {
                                    var width = img.width;
                                    var height = img.height;
                                    var newImg = {
                                      action: "addImg",
                                      img: {
                                        src: img.src,
                                        //e.target.result,
                                        name: e.target.fileName,
                                        ext: ext[ext.length - 1],
                                        width: width,
                                        height: height,
                                        video_src: ext[ext.length - 1] == "mp4" ? e.target.result : ""
                                      }
                                    };
                                    setImages(newImg);
                                  }, 500);
                                  _context3.next = 8;
                                  break;

                                case 7:
                                  setModalAlert({
                                    show: true,
                                    title: "Hubo un error al subir el video",
                                    message: "Los videos deben durar entre 15 segundos y 10 minutos"
                                  });

                                case 8:
                                case "end":
                                  return _context3.stop();
                              }
                            }
                          }, _callee3);
                        }));

                        return function (_x4) {
                          return _ref5.apply(this, arguments);
                        };
                      }()).catch(function (error) {
                        console.error("Error al obtener la duración del video:", error);
                      });
                    } else {
                      img.src = e.target.result;
                      setTimeout(function () {
                        var width = img.width;
                        var height = img.height;
                        var newImg = {
                          action: "addImg",
                          img: {
                            src: img.src,
                            //e.target.result,
                            name: e.target.fileName,
                            ext: ext[ext.length - 1],
                            width: width,
                            height: height,
                            video_src: ext[ext.length - 1] == "mp4" ? e.target.result : ""
                          }
                        };
                        setImages(newImg);
                      }, 500);
                    }

                  case 3:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));

          return function (_x3) {
            return _ref4.apply(this, arguments);
          };
        }();

        reader.onerror = function (error) {
          console.log("dropzoneError: ", error);
        };

        reader.readAsDataURL(file);
        return file;
      });
    }
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps;

  var _useState17 = (0, _react.useState)([]),
      _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
      updatedDatasheets = _useState18[0],
      setUpdatedDatasheets = _useState18[1];

  var _useState19 = (0, _react.useState)([]),
      _useState20 = (0, _slicedToArray2.default)(_useState19, 2),
      updatedDescriptions = _useState20[0],
      setUpdatedDescriptions = _useState20[1];

  var _useState21 = (0, _react.useState)(false),
      _useState22 = (0, _slicedToArray2.default)(_useState21, 2),
      imagesUploaded = _useState22[0],
      setImagesUploaded = _useState22[1];

  var _useState23 = (0, _react.useState)(),
      _useState24 = (0, _slicedToArray2.default)(_useState23, 2),
      dataImages = _useState24[0],
      setDataImages = _useState24[1];

  var _useState25 = (0, _react.useState)(new Array(product === null || product === void 0 ? void 0 : (_product$retailers = product.retailers) === null || _product$retailers === void 0 ? void 0 : _product$retailers.length).fill({
    percentage: 0
  })),
      _useState26 = (0, _slicedToArray2.default)(_useState25, 2),
      percentages = _useState26[0],
      setPercentages = _useState26[1]; // const [percentages, setPercentages] = useState([{ retailers: {} }]);


  var _useState27 = (0, _react.useState)(0),
      _useState28 = (0, _slicedToArray2.default)(_useState27, 2),
      activePercentage = _useState28[0],
      setActivePercentage = _useState28[1];

  var _useState29 = (0, _react.useState)({}),
      _useState30 = (0, _slicedToArray2.default)(_useState29, 2),
      activeRetailer = _useState30[0],
      setActiveRetailer = _useState30[1];

  var _useState31 = (0, _react.useState)([]),
      _useState32 = (0, _slicedToArray2.default)(_useState31, 2),
      services = _useState32[0],
      setServices = _useState32[1];

  var _useState33 = (0, _react.useState)([]),
      _useState34 = (0, _slicedToArray2.default)(_useState33, 2),
      servicesData = _useState34[0],
      setServicesData = _useState34[1];

  var _useState35 = (0, _react.useState)(""),
      _useState36 = (0, _slicedToArray2.default)(_useState35, 2),
      message = _useState36[0],
      setMessage = _useState36[1];

  var _useState37 = (0, _react.useState)(JSON.parse(sessionStorage.getItem("productSelected")) ? JSON.parse(sessionStorage.getItem("productSelected")) : productSelected),
      _useState38 = (0, _slicedToArray2.default)(_useState37, 2),
      product = _useState38[0],
      setProduct = _useState38[1];

  var _useState39 = (0, _react.useState)(null),
      _useState40 = (0, _slicedToArray2.default)(_useState39, 2),
      icon = _useState40[0],
      setIcon = _useState40[1];

  var _useState41 = (0, _react.useState)(product === null || product === void 0 ? void 0 : product.version),
      _useState42 = (0, _slicedToArray2.default)(_useState41, 2),
      version = _useState42[0],
      setVersion = _useState42[1];

  var _useState43 = (0, _react.useState)({}),
      _useState44 = (0, _slicedToArray2.default)(_useState43, 2),
      comments = _useState44[0],
      setComments = _useState44[1];

  var _useState45 = (0, _react.useState)(""),
      _useState46 = (0, _slicedToArray2.default)(_useState45, 2),
      comment = _useState46[0],
      setComment = _useState46[1];

  var _useState47 = (0, _react.useState)({
    "Ficha técnica": 0,
    Descripción: 0,
    Imágenes: 0
  }),
      _useState48 = (0, _slicedToArray2.default)(_useState47, 2),
      requiredNull = _useState48[0],
      setRequiredNull = _useState48[1];

  var _useState49 = (0, _react.useState)(false),
      _useState50 = (0, _slicedToArray2.default)(_useState49, 2),
      crossComment = _useState50[0],
      setCrossComment = _useState50[1];

  var _useState51 = (0, _react.useState)([]),
      _useState52 = (0, _slicedToArray2.default)(_useState51, 2),
      userGroups = _useState52[0],
      setUserGroups = _useState52[1];

  var _useState53 = (0, _react.useState)({}),
      _useState54 = (0, _slicedToArray2.default)(_useState53, 2),
      assig = _useState54[0],
      setAssig = _useState54[1];

  var _useState55 = (0, _react.useState)([]),
      _useState56 = (0, _slicedToArray2.default)(_useState55, 2),
      selectedImages = _useState56[0],
      setSelectedImages = _useState56[1];

  var _useState57 = (0, _react.useState)([]),
      _useState58 = (0, _slicedToArray2.default)(_useState57, 2),
      componentsArray = _useState58[0],
      setComponentsArray = _useState58[1];

  var _useState59 = (0, _react.useState)(false),
      _useState60 = (0, _slicedToArray2.default)(_useState59, 2),
      checkAll = _useState60[0],
      setCheckAll = _useState60[1];

  var isRetailer = user === null || user === void 0 ? void 0 : user.is_retailer;

  var _useState61 = (0, _react.useState)(true),
      _useState62 = (0, _slicedToArray2.default)(_useState61, 2),
      loading = _useState62[0],
      setLoading = _useState62[1];

  var _useState63 = (0, _react.useState)("-"),
      _useState64 = (0, _slicedToArray2.default)(_useState63, 2),
      retailerStatus = _useState64[0],
      setRetailerStatus = _useState64[1];

  var _useState65 = (0, _react.useState)([]),
      _useState66 = (0, _slicedToArray2.default)(_useState65, 2),
      statusArray = _useState66[0],
      setStatusArray = _useState66[1];

  var _useState67 = (0, _react.useState)(null),
      _useState68 = (0, _slicedToArray2.default)(_useState67, 2),
      socketType = _useState68[0],
      setSocketType = _useState68[1];

  var _useState69 = (0, _react.useState)(loading),
      _useState70 = (0, _slicedToArray2.default)(_useState69, 2),
      saving = _useState70[0],
      setSaving = _useState70[1];

  var _useCloseModal = (0, _customHooks.useCloseModal)("version-selector"),
      _useCloseModal2 = (0, _slicedToArray2.default)(_useCloseModal, 2),
      showVersionSelector = _useCloseModal2[0],
      setShowVersionSelector = _useCloseModal2[1];

  var shotThd = [58, 59, 60, 61].includes(activeRetailer.id);

  var _useState71 = (0, _react.useState)(null),
      _useState72 = (0, _slicedToArray2.default)(_useState71, 2),
      auditableVersion = _useState72[0],
      setAuditableVersion = _useState72[1];

  var _useState73 = (0, _react.useState)([]),
      _useState74 = (0, _slicedToArray2.default)(_useState73, 2),
      auditServices = _useState74[0],
      setAuditServices = _useState74[1];

  var _useState75 = (0, _react.useState)([]),
      _useState76 = (0, _slicedToArray2.default)(_useState75, 2),
      auditDatasheets = _useState76[0],
      setAuditDatasheets = _useState76[1];

  var _useState77 = (0, _react.useState)([]),
      _useState78 = (0, _slicedToArray2.default)(_useState77, 2),
      auditDescriptions = _useState78[0],
      setAuditDescriptions = _useState78[1];

  var _useState79 = (0, _react.useState)([]),
      _useState80 = (0, _slicedToArray2.default)(_useState79, 2),
      auditImages = _useState80[0],
      setAuditImages = _useState80[1];

  var _useState81 = (0, _react.useState)(false),
      _useState82 = (0, _slicedToArray2.default)(_useState81, 2),
      compare = _useState82[0],
      setCompare = _useState82[1];

  var _useState83 = (0, _react.useState)(),
      _useState84 = (0, _slicedToArray2.default)(_useState83, 2),
      observation = _useState84[0],
      setObservation = _useState84[1];

  var _useState85 = (0, _react.useState)(false),
      _useState86 = (0, _slicedToArray2.default)(_useState85, 2),
      valRejAll = _useState86[0],
      setValRejAll = _useState86[1];

  var _useState87 = (0, _react.useState)({
    show: false,
    title: "",
    message: "",
    errorInputMessage: false
  }),
      _useState88 = (0, _slicedToArray2.default)(_useState87, 2),
      modalAlert = _useState88[0],
      setModalAlert = _useState88[1];

  var _useState89 = (0, _react.useState)([]),
      _useState90 = (0, _slicedToArray2.default)(_useState89, 2),
      desc = _useState90[0],
      setDesc = _useState90[1];

  var _useState91 = (0, _react.useState)([]),
      _useState92 = (0, _slicedToArray2.default)(_useState91, 2),
      fich = _useState92[0],
      setFich = _useState92[1];

  var _useState93 = (0, _react.useState)([]),
      _useState94 = (0, _slicedToArray2.default)(_useState93, 2),
      imag = _useState94[0],
      setImag = _useState94[1];

  var _useState95 = (0, _react.useState)(false),
      _useState96 = (0, _slicedToArray2.default)(_useState95, 2),
      isObservationVisible = _useState96[0],
      setObservationVisible = _useState96[1];

  var toggleObservation = function toggleObservation() {
    setObservationVisible(!isObservationVisible);
  }; // const handleClickOutside = (event) => {
  //   if (
  //     isObservationVisible &&
  //     !event.target.closest(".Observation") &&
  //     !event.target.closest(".Container")
  //   ) {
  //     hideObservation();
  //   }
  // };
  // useEffect(() => {
  //   document.addEventListener("click", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("click", handleClickOutside);
  //   };
  // }, [isObservationVisible]);


  var hideObservation = function hideObservation() {
    setObservationVisible(false);
  };

  var handleCommentSubmit = function handleCommentSubmit(e) {
    e.preventDefault();
    var commentText = document.querySelector("#commentary-box .ql-container .ql-editor > p").innerHTML;
    createComment(e, commentText, activeTab);
  };

  (0, _react.useEffect)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
    var _ref7, id_article;

    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _ref7 = (product === null || product === void 0 ? void 0 : product.article) || {}, id_article = _ref7.id_article;

            if (!id_article) {
              _context5.next = 4;
              break;
            }

            _context5.next = 4;
            return (0, _utils.getAuditVersion)(id_article, setAuditableVersion, token);

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  })), []);

  var loadAuditableData = /*#__PURE__*/function () {
    var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
      var _product$article, _product$article2, _product$article3, _auditServices;

      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!auditableVersion) {
                _context6.next = 7;
                break;
              }

              _context6.next = 3;
              return (0, _data2.getRetailerServices)(product === null || product === void 0 ? void 0 : (_product$article = product.article) === null || _product$article === void 0 ? void 0 : _product$article.id_article, product === null || product === void 0 ? void 0 : (_product$article2 = product.article) === null || _product$article2 === void 0 ? void 0 : _product$article2.category, parseInt(product === null || product === void 0 ? void 0 : (_product$article3 = product.article) === null || _product$article3 === void 0 ? void 0 : _product$article3.id_category), auditableVersion.version, token);

            case 3:
              _auditServices = _context6.sent;
              (0, _utils.getInputsData)(_auditServices, activeRetailer, setAuditDatasheets, setAuditDescriptions);
              setAuditServices(_auditServices);
              setAuditImages(_auditServices[2]);

            case 7:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function loadAuditableData() {
      return _ref8.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    if (auditableVersion) {
      loadAuditableData();
    }
  }, [auditableVersion]);
  (0, _react.useEffect)(function () {
    checkAll && setSelectedImages(images.values);
  }, [checkAll]);

  var loadData = /*#__PURE__*/function () {
    var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7() {
      var _product$article4, _product$article5, _product$article6, _services$, _services$$values, _product$retailersAva, _services, data, headers;

      return _regenerator.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return (0, _data2.getRetailerServices)(product === null || product === void 0 ? void 0 : (_product$article4 = product.article) === null || _product$article4 === void 0 ? void 0 : _product$article4.id_article, product === null || product === void 0 ? void 0 : (_product$article5 = product.article) === null || _product$article5 === void 0 ? void 0 : _product$article5.category, parseInt(product === null || product === void 0 ? void 0 : (_product$article6 = product.article) === null || _product$article6 === void 0 ? void 0 : _product$article6.id_category), version, token);

            case 3:
              _services = _context7.sent;

              if (auditableVersion) {
                loadAuditableData();
              } //Converts the data inside the datasheets object to array


              setServices(_services);
              getServices();
              setImages({
                action: "init",
                init: _services[2]
              });
              if (((_services$ = _services[2]) === null || _services$ === void 0 ? void 0 : (_services$$values = _services$.values) === null || _services$$values === void 0 ? void 0 : _services$$values.length) > 0) setActiveImage(0);
              data = [{
                id_article: product.article.id_article,
                id_category: product.article.id_category,
                version: product.version,
                id_retailer_array: ((_product$retailersAva = product.retailersAvailable) !== null && _product$retailersAva !== void 0 ? _product$retailersAva : product.retailers).map(function (_ref10) {
                  var id = _ref10.id;
                  return id;
                })
              }];
              headers = {
                Authorization: token
              };
              (0, _data2.getPercentage)({
                data: data,
                headers: headers
              }).then(function (res) {
                setPercentages(res[0]);
              });
              setLoading(false);
              _context7.next = 18;
              break;

            case 15:
              _context7.prev = 15;
              _context7.t0 = _context7["catch"](0);
              console.log(_context7.t0);

            case 18:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[0, 15]]);
    }));

    return function loadData() {
      return _ref9.apply(this, arguments);
    };
  }();

  var getServices = /*#__PURE__*/function () {
    var _ref11 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8() {
      var _product$article7, _product$article8, _servicesResponse$dat;

      var servicesResponse, parsedResponse, retailers, retailerResponse, active;
      return _regenerator.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _axios.default.get("".concat(process.env.REACT_APP_SERVICES_ENDPOINT, "?articleId=").concat(product === null || product === void 0 ? void 0 : (_product$article7 = product.article) === null || _product$article7 === void 0 ? void 0 : _product$article7.id_article, "&orderId=").concat((product === null || product === void 0 ? void 0 : (_product$article8 = product.article) === null || _product$article8 === void 0 ? void 0 : _product$article8.id_order) || product.orderId, "&end=true"));

            case 2:
              servicesResponse = _context8.sent;
              parsedResponse = JSON.parse(servicesResponse === null || servicesResponse === void 0 ? void 0 : (_servicesResponse$dat = servicesResponse.data) === null || _servicesResponse$dat === void 0 ? void 0 : _servicesResponse$dat.body).data;
              retailers = product.retailers || product.retailersAvailable;
              retailerResponse = parsedResponse === null || parsedResponse === void 0 ? void 0 : parsedResponse.map(function (srv) {
                return srv.id_retailer;
              });
              active = retailers === null || retailers === void 0 ? void 0 : retailers.find(function (retailer) {
                return retailerResponse.includes(retailer.id);
              });
              !activeRetailer.id && setActiveRetailer(active ? active : retailers[0]);
              setServicesData(parsedResponse);

            case 9:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function getServices() {
      return _ref11.apply(this, arguments);
    };
  }();

  var translateConcept = function translateConcept(concept) {
    var translation = {
      datasheet: "Ficha técnica",
      description: "Descripción",
      images: "Imágenes"
    };
    return translation[concept];
  };

  var getComments = /*#__PURE__*/function () {
    var _ref12 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9() {
      var _product$article9, _product$article10, _product$article11;

      var tab,
          commentsResponse,
          comments,
          _args9 = arguments;
      return _regenerator.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              tab = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : "Descripción";
              _context9.next = 3;
              return Promise.all([_axios.default.get("".concat(process.env.REACT_APP_COMMENTS_ENDPOINT, "?articleId=").concat(product === null || product === void 0 ? void 0 : (_product$article9 = product.article) === null || _product$article9 === void 0 ? void 0 : _product$article9.id_article, "&concept=description&orderIdColab=").concat(product === null || product === void 0 ? void 0 : product.orderId, "&version=").concat(version)), _axios.default.get("".concat(process.env.REACT_APP_COMMENTS_ENDPOINT, "?articleId=").concat(product === null || product === void 0 ? void 0 : (_product$article10 = product.article) === null || _product$article10 === void 0 ? void 0 : _product$article10.id_article, "&concept=datasheet&orderIdColab=").concat(product === null || product === void 0 ? void 0 : product.orderId, "&version=").concat(version)), _axios.default.get("".concat(process.env.REACT_APP_COMMENTS_ENDPOINT, "?articleId=").concat(product === null || product === void 0 ? void 0 : (_product$article11 = product.article) === null || _product$article11 === void 0 ? void 0 : _product$article11.id_article, "&concept=images&orderIdColab=").concat(product === null || product === void 0 ? void 0 : product.orderId, "&version=").concat(version))]);

            case 3:
              commentsResponse = _context9.sent;
              comments = {};
              commentsResponse.forEach(function (comment) {
                var _comment$data, _JSON$parse, _JSON$parse$data$, _comment$data2, _comment$data3;

                return JSON.parse(comment === null || comment === void 0 ? void 0 : (_comment$data = comment.data) === null || _comment$data === void 0 ? void 0 : _comment$data.body).data[0] && (comments[translateConcept((_JSON$parse = JSON.parse(comment === null || comment === void 0 ? void 0 : (_comment$data2 = comment.data) === null || _comment$data2 === void 0 ? void 0 : _comment$data2.body)) === null || _JSON$parse === void 0 ? void 0 : (_JSON$parse$data$ = _JSON$parse.data[0]) === null || _JSON$parse$data$ === void 0 ? void 0 : _JSON$parse$data$.concept)] = JSON.parse(comment === null || comment === void 0 ? void 0 : (_comment$data3 = comment.data) === null || _comment$data3 === void 0 ? void 0 : _comment$data3.body).data[0]);
              });
              setComment(comments[tab]);
              setComments(comments);

            case 8:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function getComments() {
      return _ref12.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10() {
    var arr;
    return _regenerator.default.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            setLoading(true);
            loadData();
            getComments();
            _context10.t0 = setUserGroups;
            _context10.next = 6;
            return (0, _data2.fetchUsers)(token);

          case 6:
            _context10.t1 = _context10.sent;
            (0, _context10.t0)(_context10.t1);
            arr = [];
            _context10.t2 = user.id_role;
            _context10.next = _context10.t2 === 7 ? 12 : _context10.t2 === 8 ? 12 : _context10.t2 === 4 ? 14 : _context10.t2 === 5 ? 14 : _context10.t2 === 6 ? 16 : 18;
            break;

          case 12:
            arr = ["PA", "AS", "CA", "RC", "RA", "RP", "RCA"];
            return _context10.abrupt("break", 20);

          case 14:
            arr = ["RC", "AC", "AA", "AP", "ACA"];
            return _context10.abrupt("break", 20);

          case 16:
            arr = ["RP", "RCA", "AC", "RA"];
            return _context10.abrupt("break", 20);

          case 18:
            arr = [];
            return _context10.abrupt("break", 20);

          case 20:
            setStatusArray(arr);

          case 21:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  })), [product, version]);

  var loadAssignations = function loadAssignations(currentProduct) {
    var _currentProduct$artic, _currentProduct$artic2, _currentProduct$artic3, _currentProduct$artic4, _currentProduct$artic5, _currentProduct$artic6;

    setAssig({
      Descripción: {
        assignations: [{
          collaboratorType: "especialist",
          id: currentProduct === null || currentProduct === void 0 ? void 0 : (_currentProduct$artic = currentProduct.article) === null || _currentProduct$artic === void 0 ? void 0 : _currentProduct$artic.id_description_especialist
        }, {
          collaboratorType: "facilitator",
          id: currentProduct === null || currentProduct === void 0 ? void 0 : (_currentProduct$artic2 = currentProduct.article) === null || _currentProduct$artic2 === void 0 ? void 0 : _currentProduct$artic2.id_description_facilitator
        }],
        collaborators: {
          especialist: userGroups[0] || [],
          facilitator: userGroups[2] || []
        }
      },
      "Ficha técnica": {
        assignations: [{
          collaboratorType: "especialist",
          id: currentProduct === null || currentProduct === void 0 ? void 0 : (_currentProduct$artic3 = currentProduct.article) === null || _currentProduct$artic3 === void 0 ? void 0 : _currentProduct$artic3.id_datasheet_especialist
        }, {
          collaboratorType: "facilitator",
          id: currentProduct === null || currentProduct === void 0 ? void 0 : (_currentProduct$artic4 = currentProduct.article) === null || _currentProduct$artic4 === void 0 ? void 0 : _currentProduct$artic4.id_datasheet_facilitator
        }],
        collaborators: {
          especialist: userGroups[0] || [],
          facilitator: userGroups[2] || []
        }
      },
      Imágenes: {
        assignations: [{
          collaboratorType: "especialist",
          id: currentProduct === null || currentProduct === void 0 ? void 0 : (_currentProduct$artic5 = currentProduct.article) === null || _currentProduct$artic5 === void 0 ? void 0 : _currentProduct$artic5.id_images_especialist
        }, {
          collaboratorType: "facilitator",
          id: currentProduct === null || currentProduct === void 0 ? void 0 : (_currentProduct$artic6 = currentProduct.article) === null || _currentProduct$artic6 === void 0 ? void 0 : _currentProduct$artic6.id_images_facilitator
        }],
        collaborators: {
          especialist: userGroups[1] || [],
          facilitator: userGroups[3] || []
        }
      }
    });
  };

  (0, _react.useEffect)(function () {
    loadAssignations(product);
  }, [userGroups]);
  (0, _react.useEffect)(function () {
    var _Object$keys, _percentages$product$, _retailers$;

    var retailers = (product === null || product === void 0 ? void 0 : product.retailersAvailable) || (product === null || product === void 0 ? void 0 : product.retailers);

    if (((_Object$keys = Object.keys((_percentages$product$ = percentages[product.article.id_article]) !== null && _percentages$product$ !== void 0 ? _percentages$product$ : {})) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0) {
      retailers === null || retailers === void 0 ? void 0 : retailers.forEach(function (retailer, index) {
        var _percentages$product$2;

        retailer["percentage"] = Number((_percentages$product$2 = percentages[product.article.id_article][retailer.id]) === null || _percentages$product$2 === void 0 ? void 0 : _percentages$product$2.percentageRequired);
      });
    }

    setActivePercentage((_retailers$ = retailers[0]) === null || _retailers$ === void 0 ? void 0 : _retailers$.percentage);
  }, [percentages]);
  (0, _react.useEffect)(function () {
    (0, _utils.getInputsData)(services, activeRetailer, setDatasheets, setDescriptions);
    auditableVersion && loadAuditableData();
    setActivePercentage(Math.round(activeRetailer === null || activeRetailer === void 0 ? void 0 : activeRetailer.percentage, 0));
    (activeRetailer === null || activeRetailer === void 0 ? void 0 : activeRetailer.id) && setImages({
      action: "orderImages",
      retailerId: activeRetailer.id
    });
  }, [activeRetailer, services]);

  var thumbs = function thumbs() {
    var _images$imageType, _images$imagePackagin, _images$imageShotType, _images$values;

    var imageInputs = socketType === null || socketType === void 0 ? void 0 : socketType.slice();
    var imageType = images === null || images === void 0 ? void 0 : (_images$imageType = images.imageType) === null || _images$imageType === void 0 ? void 0 : _images$imageType.map(function (e) {
      return {
        value: e === null || e === void 0 ? void 0 : e.id,
        name: e === null || e === void 0 ? void 0 : e.name
      };
    });
    var imagePackagingType = images === null || images === void 0 ? void 0 : (_images$imagePackagin = images.imagePackagingType) === null || _images$imagePackagin === void 0 ? void 0 : _images$imagePackagin.map(function (e) {
      return {
        value: e === null || e === void 0 ? void 0 : e.id,
        name: e === null || e === void 0 ? void 0 : e.name
      };
    });
    var imageShotType = images === null || images === void 0 ? void 0 : (_images$imageShotType = images.imageShotType) === null || _images$imageShotType === void 0 ? void 0 : _images$imageShotType.map(function (e) {
      return {
        value: e === null || e === void 0 ? void 0 : e.id,
        name: e === null || e === void 0 ? void 0 : e.type_shot
      };
    });
    return images === null || images === void 0 ? void 0 : (_images$values = images.values) === null || _images$values === void 0 ? void 0 : _images$values.map(function (image, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_GalleryElement.GalleryElement, {
        setCheckAll: setCheckAll,
        image: image,
        gridLayout: imageLayout,
        id: "gallery-element-" + index,
        index: index + "-" + image.name + "-" + compare,
        number: index,
        imageType: imageType,
        imagePackagingType: imagePackagingType,
        imageInputs: imageInputs,
        imageShotType: imageShotType,
        setSocketType: setSocketType,
        changeImage: setImages,
        selectedImages: selectedImages,
        setSelectedImages: setSelectedImages,
        auditImages: auditImages,
        compare: compare
      }, index + "-" + image.name);
    });
  };

  var saveDescriptions = /*#__PURE__*/function () {
    var _ref14 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11() {
      var dataClean, _product$article12, productTemp, articleId, dataObject, res, _JSON$parse2, newStatus, newArticleStatus;

      return _regenerator.default.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              dataClean = updatedDescriptions.filter(function (f) {
                return f.value !== "";
              });

              if (!(dataClean.length > 0)) {
                _context11.next = 26;
                break;
              }

              setLoading(true);
              productTemp = product;
              articleId = product === null || product === void 0 ? void 0 : (_product$article12 = product.article) === null || _product$article12 === void 0 ? void 0 : _product$article12.id_article;
              dataObject = {
                articleId: articleId,
                articleData: dataClean
              };
              if (product !== null && product !== void 0 && product.orderId) dataObject["orderId"] = product === null || product === void 0 ? void 0 : product.orderId;
              _context11.prev = 7;
              _context11.next = 10;
              return _axios.default.put("".concat(process.env.REACT_APP_ARTICLE_DATA_ENDPOINT, "?description=true&version=").concat(version), dataObject, {
                headers: {
                  Authorization: token
                }
              });

            case 10:
              res = _context11.sent;

              if (!(res.data.statusCode === 200)) {
                _context11.next = 21;
                break;
              }

              _JSON$parse2 = JSON.parse(res.data.body), newStatus = _JSON$parse2.newStatus, newArticleStatus = _JSON$parse2.newArticleStatus;
              if (newArticleStatus) productTemp.status = newArticleStatus[articleId];
              if (newStatus) productTemp.description_status = newStatus;
              setProduct(productTemp);
              sessionStorage.setItem("productSelected", JSON.stringify(productTemp));
              setUpdatedDescriptions([]);
              setMessage("Descripciones guardadas con éxito");
              _context11.next = 21;
              return loadData();

            case 21:
              _context11.next = 26;
              break;

            case 23:
              _context11.prev = 23;
              _context11.t0 = _context11["catch"](7);
              console.log(_context11.t0);

            case 26:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[7, 23]]);
    }));

    return function saveDescriptions() {
      return _ref14.apply(this, arguments);
    };
  }();

  var saveDatasheets = /*#__PURE__*/function () {
    var _ref15 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12() {
      var dataClean, _product$article13, productTemp, articleId, dataObject, res, _JSON$parse3, newStatus, newArticleStatus;

      return _regenerator.default.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              dataClean = updatedDatasheets.filter(function (f) {
                return f.value !== "";
              });

              if (!(dataClean.length > 0)) {
                _context12.next = 26;
                break;
              }

              setLoading(true);
              productTemp = product;
              articleId = product === null || product === void 0 ? void 0 : (_product$article13 = product.article) === null || _product$article13 === void 0 ? void 0 : _product$article13.id_article;
              dataObject = {
                articleId: articleId,
                articleData: dataClean
              };
              if (product !== null && product !== void 0 && product.orderId) dataObject["orderId"] = product === null || product === void 0 ? void 0 : product.orderId;
              _context12.prev = 7;
              _context12.next = 10;
              return _axios.default.put("".concat(process.env.REACT_APP_ARTICLE_DATA_ENDPOINT, "?datasheet=true&version=").concat(version), dataObject, {
                headers: {
                  Authorization: token
                }
              });

            case 10:
              res = _context12.sent;

              if (!(res.data.statusCode === 200)) {
                _context12.next = 21;
                break;
              }

              _JSON$parse3 = JSON.parse(res.data.body), newStatus = _JSON$parse3.newStatus, newArticleStatus = _JSON$parse3.newArticleStatus;
              if (newArticleStatus) productTemp.status = newArticleStatus[articleId];
              if (newStatus) productTemp.datasheet_status = newStatus;
              setProduct(productTemp);
              sessionStorage.setItem("productSelected", JSON.stringify(productTemp));
              setUpdatedDatasheets([]);
              setMessage("Fichas técnicas guardadas");
              _context12.next = 21;
              return loadData();

            case 21:
              _context12.next = 26;
              break;

            case 23:
              _context12.prev = 23;
              _context12.t0 = _context12["catch"](7);
              console.log(_context12.t0);

            case 26:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, null, [[7, 23]]);
    }));

    return function saveDatasheets() {
      return _ref15.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    var _images$inputs;

    var imageInputs = images === null || images === void 0 ? void 0 : (_images$inputs = images.inputs) === null || _images$inputs === void 0 ? void 0 : _images$inputs.map(function (e) {
      var _images$values2;

      return {
        value: e === null || e === void 0 ? void 0 : e.id,
        name: e === null || e === void 0 ? void 0 : e.name,
        required: e === null || e === void 0 ? void 0 : e.required,
        active: images === null || images === void 0 ? void 0 : (_images$values2 = images.values) === null || _images$values2 === void 0 ? void 0 : _images$values2.some(function (value) {
          return (value === null || value === void 0 ? void 0 : value.image_id) === (e === null || e === void 0 ? void 0 : e.id);
        })
      };
    });
    setSocketType(imageInputs);
  }, [images]);
  var updateImages = (0, _react.useCallback)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13() {
    var _images$values3, _images$attrForImgs, _product$article14, _data$articleData, _data$articleData2, _data$updateImages;

    var imagesList, imagesListTemp, duplicated, attrForImgs, data, valid, _data$updateImages2, _data$articleData3, _data$articleData4, _data$articleData5, promiseArray;

    return _regenerator.default.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            imagesList = images === null || images === void 0 ? void 0 : (_images$values3 = images.values) === null || _images$values3 === void 0 ? void 0 : _images$values3.slice();
            imagesListTemp = imagesList === null || imagesList === void 0 ? void 0 : imagesList.reduce(function (acc, image) {
              acc[image === null || image === void 0 ? void 0 : image.image_id] = ++acc[image === null || image === void 0 ? void 0 : image.image_id] || 0;
              return acc;
            }, {});
            duplicated = imagesList === null || imagesList === void 0 ? void 0 : imagesList.filter(function (image) {
              return imagesListTemp[image === null || image === void 0 ? void 0 : image.image_id];
            });
            attrForImgs = Object.values((_images$attrForImgs = images === null || images === void 0 ? void 0 : images.attrForImgs) !== null && _images$attrForImgs !== void 0 ? _images$attrForImgs : {}).pop();
            data = {
              articleId: product === null || product === void 0 ? void 0 : (_product$article14 = product.article) === null || _product$article14 === void 0 ? void 0 : _product$article14.id_article,
              attrReqImgs: attrForImgs === null || attrForImgs === void 0 ? void 0 : attrForImgs.map(function (e) {
                var _e$value;

                return {
                  attrId: e.id,
                  value: (_e$value = e.value) !== null && _e$value !== void 0 ? _e$value : "-"
                };
              }),
              articleData: imagesList === null || imagesList === void 0 ? void 0 : imagesList.filter(function (e) {
                return !e.id;
              }),
              updateImages: imagesList === null || imagesList === void 0 ? void 0 : imagesList.filter(function (e) {
                return e.id;
              })
            };
            if (product !== null && product !== void 0 && product.orderId) data["orderId"] = product === null || product === void 0 ? void 0 : product.orderId;
            valid = (data === null || data === void 0 ? void 0 : (_data$articleData = data.articleData) === null || _data$articleData === void 0 ? void 0 : _data$articleData.length) === 0 ? true : data === null || data === void 0 ? void 0 : (_data$articleData2 = data.articleData) === null || _data$articleData2 === void 0 ? void 0 : _data$articleData2.every(function (e, i) {
              if (e !== null && e !== void 0 && e.image_id && e !== null && e !== void 0 && e.packing_type && e !== null && e !== void 0 && e.image_type) {
                return true;
              }

              return false;
            });

            if (valid && (data === null || data === void 0 ? void 0 : (_data$updateImages = data.updateImages) === null || _data$updateImages === void 0 ? void 0 : _data$updateImages.length) > 0 && (duplicated === null || duplicated === void 0 ? void 0 : duplicated.length) === 0) {
              valid = data === null || data === void 0 ? void 0 : (_data$updateImages2 = data.updateImages) === null || _data$updateImages2 === void 0 ? void 0 : _data$updateImages2.every(function (e, i) {
                if (e !== null && e !== void 0 && e.image_id && e !== null && e !== void 0 && e.packing_type && e !== null && e !== void 0 && e.image_type) {
                  return true;
                }

                return false;
              });
            }

            if (!(valid && (duplicated === null || duplicated === void 0 ? void 0 : duplicated.length) === 0)) {
              _context13.next = 30;
              break;
            }

            setLoading(true);
            _context13.prev = 10;
            data === null || data === void 0 ? void 0 : (_data$articleData3 = data.articleData) === null || _data$articleData3 === void 0 ? void 0 : _data$articleData3.forEach(function (e) {
              e.uuid = (0, _uuid.v4)();
            });
            setDataImages(data);

            if (!((data === null || data === void 0 ? void 0 : (_data$articleData4 = data.articleData) === null || _data$articleData4 === void 0 ? void 0 : _data$articleData4.length) > 0)) {
              _context13.next = 22;
              break;
            }

            setImagesUploaded(false);
            promiseArray = [];
            data === null || data === void 0 ? void 0 : (_data$articleData5 = data.articleData) === null || _data$articleData5 === void 0 ? void 0 : _data$articleData5.forEach(function (e) {
              var file;

              if (e.ext == "mp4") {
                file = Buffer.from(e.video_src.replace(/^data:video\/\w+;base64,/, ""), "base64");
                e.video_src = "";
              } else {
                file = Buffer.from(e.src.replace(/^data:image\/\w+;base64,/, ""), "base64");
              }

              var params = {
                ACL: "public-read",
                Body: file,
                Bucket: S3_BUCKET,
                Key: "id-".concat(data.articleId, "/").concat(version, "/").concat(e === null || e === void 0 ? void 0 : e.image_id, "-").concat(e === null || e === void 0 ? void 0 : e.uuid, ".").concat(e === null || e === void 0 ? void 0 : e.ext)
              };
              promiseArray.push(myBucket.putObject(params).promise());
            });
            _context13.next = 19;
            return Promise.all(promiseArray);

          case 19:
            setImagesUploaded(true);
            _context13.next = 23;
            break;

          case 22:
            setImagesUploaded(true);

          case 23:
            _context13.next = 28;
            break;

          case 25:
            _context13.prev = 25;
            _context13.t0 = _context13["catch"](10);
            console.log(_context13.t0); // setMainLoading(false);

          case 28:
            _context13.next = 31;
            break;

          case 30:
            // setMainLoading(false);
            setMessage("Completa los campos que solicita cada una de la imágenes o hay imágenes con el mismo tipo de toma.\nRecuerda hay campos obligatorios y no podras avanzar si no estan completos.");

          case 31:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, null, [[10, 25]]);
  })), [images, imagesUploaded]);
  (0, _react.useEffect)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14() {
    var res, _product$article15, productTemp, _JSON$parse4, newStatus, newArticleStatus;

    return _regenerator.default.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            if (!imagesUploaded) {
              _context14.next = 23;
              break;
            }

            dataImages.articleData = dataImages === null || dataImages === void 0 ? void 0 : dataImages.articleData.map(function (e) {
              delete e.src;
              e.imageID = e.image_id;
              e.packingType = e.packing_type;
              e.imageType = e.image_type;
              if (product !== null && product !== void 0 && product.orderId) e["orderId"] = product === null || product === void 0 ? void 0 : product.orderId;
              return e;
            });
            _context14.prev = 2;
            _context14.next = 5;
            return _axios.default.put("".concat(process.env.REACT_APP_ARTICLE_DATA_ENDPOINT, "?image=true&version=").concat(version), dataImages, {
              headers: {
                Authorization: token
              }
            });

          case 5:
            res = _context14.sent;

            if (!(res.data.statusCode === 200)) {
              _context14.next = 18;
              break;
            }

            productTemp = product;
            _JSON$parse4 = JSON.parse(res.data.body), newStatus = _JSON$parse4.newStatus, newArticleStatus = _JSON$parse4.newArticleStatus;
            if (newArticleStatus) productTemp.status = newArticleStatus[product === null || product === void 0 ? void 0 : (_product$article15 = product.article) === null || _product$article15 === void 0 ? void 0 : _product$article15.id_article];
            if (newStatus) productTemp.images_status = newStatus;
            setProduct(productTemp);
            sessionStorage.setItem("productSelected", JSON.stringify(productTemp));
            setImages({});
            setMessage("Imágenes guardadas con éxito");
            sessionStorage.removeItem("imagesList");
            _context14.next = 18;
            return loadData();

          case 18:
            _context14.next = 23;
            break;

          case 20:
            _context14.prev = 20;
            _context14.t0 = _context14["catch"](2);
            console.log(_context14.t0);

          case 23:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, null, [[2, 20]]);
  })), [dataImages, imagesUploaded]);

  var evaluationFinished = function evaluationFinished(userId, tab, statusArray) {
    var _srv$find, _srv$find$status, _product$;

    var srv = servicesData.filter(function (serv) {
      return serv.service === getConcept(tab);
    });
    var srvActive = (_srv$find = srv.find(function (serv) {
      return serv.id_retailer === (activeRetailer === null || activeRetailer === void 0 ? void 0 : activeRetailer.id);
    })) === null || _srv$find === void 0 ? void 0 : (_srv$find$status = _srv$find.status) === null || _srv$find$status === void 0 ? void 0 : _srv$find$status.replace(/.*\//, "");
    var currStatus = (_product$ = product["".concat(getConcept(tab), "_status")]) === null || _product$ === void 0 ? void 0 : _product$.replace(/.*\//, "");
    var unvalidated = ["IE", "CA"].includes(currStatus);
    var auditorUnvalidated = !["RA", "AA", "ACA", "AP"].includes(currStatus);

    switch (userId) {
      case 7:
      case 8:
        return statusArray.includes(srvActive) && statusArray.includes(product === null || product === void 0 ? void 0 : product.status) || srv.filter(function (serv) {
          var _serv$status;

          return statusArray.includes((_serv$status = serv.status) === null || _serv$status === void 0 ? void 0 : _serv$status.replace(/.*\//, ""));
        }).length === srv.length;

      case 4:
      case 5:
        return unvalidated && ["CA", "IE"].includes(product.status) && // "RC", "AC", "AA", "AP", "ACA"
        srv.filter(function (serv) {
          return statusArray.includes(serv.status);
        }).length === srv.length;

      case 6:
        return statusArray.includes(product.status) && // RP, RCA, AC, RA true
        srv.every(function (serv) {
          return ["RA", "AA", "AP", "ACA"].includes(serv.status);
        }) && auditorUnvalidated;

      default:
        break;
    }
  };

  var getConcept = function getConcept(tab) {
    switch (tab) {
      case "Descripción":
        return "description";

      case "Ficha técnica":
        return "datasheet";

      case "Imágenes":
        return "images";
    }
  };

  var approveRejectButtons = function approveRejectButtons(action) {
    var _servicesData$find, _servicesData$find$st;

    var concept = getConcept(action || activeTab);
    var retailerStatus = (_servicesData$find = servicesData.find(function (srv) {
      return srv.id_retailer === (activeRetailer === null || activeRetailer === void 0 ? void 0 : activeRetailer.id) && srv.service === concept;
    })) === null || _servicesData$find === void 0 ? void 0 : (_servicesData$find$st = _servicesData$find.status) === null || _servicesData$find$st === void 0 ? void 0 : _servicesData$find$st.replace(/.*\//, ""); //sessionStorage product

    var adminFacilitatorCanEvaluate = retailerStatus === "IE" && [1, 4, 5].includes(user.id_role);
    var adminAuditorCanEvaluate = ["AC", "RP", "RCA", "SAC"].includes(retailerStatus) && [1, 6].includes(user.id_role);
    return adminFacilitatorCanEvaluate || adminAuditorCanEvaluate;
  };

  var approveRejectAllButtons = function approveRejectAllButtons() {
    var concepts = [];

    switch (user.id_role) {
      case 4:
        concepts = ["description", "datasheet"];
        break;

      case 5:
        concepts = ["images"];
        break;

      default:
        concepts = ["description", "datasheet", "images"];
        break;
    }

    var services = servicesData.filter(function (_ref18) {
      var service = _ref18.service;
      return concepts.includes(service);
    });
    var adminFacilitatorCanEvaluate = services.every(function (srv) {
      var _srv$status;

      return (srv === null || srv === void 0 ? void 0 : (_srv$status = srv.status) === null || _srv$status === void 0 ? void 0 : _srv$status.replace(/.*\//, "")) === "IE";
    }) && [1, 4, 5].includes(user.id_role); //sessionStorage product

    var adminAuditorCanEvaluate = servicesData.every(function (srv) {
      var _srv$status2;

      return ["AC", "RP", "RCA"].includes(srv === null || srv === void 0 ? void 0 : (_srv$status2 = srv.status) === null || _srv$status2 === void 0 ? void 0 : _srv$status2.replace(/.*\//, ""));
    }) && [1, 6].includes(user.id_role);
    return adminFacilitatorCanEvaluate || adminAuditorCanEvaluate;
  };

  var getSectionIcon = function getSectionIcon() {
    switch (activeTab) {
      case "Ficha técnica":
        setIcon(_attributesSent.default);
        break;

      case "Descripción":
        setIcon(_descriptionSent.default);
        break;

      case "Imágenes":
        setIcon(_uploadingImages.default);
        break;

      default:
        break;
    }
  };

  var sendToFacilitator = /*#__PURE__*/function () {
    var _ref19 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15(result) {
      var concept, productTemp, evalStatus, articleId, orderId, data, res, _message, specialistDone, _JSON$parse5, newStatus, newOrderStatus, newArticleStatus, messageToChat, _data;

      return _regenerator.default.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              setLoading(true);
              _context15.prev = 1;
              concept = getConcept(activeTab);
              productTemp = (0, _objectSpread2.default)({}, product);
              evalStatus = retailerStatus;
              articleId = product.article.id_article;
              orderId = product.orderId;
              data = {
                articleId: articleId,
                orderId: orderId,
                concept: concept,
                evalStatus: evalStatus,
                retailerId: activeRetailer.id
              };

              if (!result) {
                _context15.next = 16;
                break;
              }

              data.result = result;
              _context15.next = 12;
              return _axios.default.put("".concat(process.env.REACT_APP_EVALUATION_ENDPOINT), data, {
                headers: {
                  Authorization: token
                }
              });

            case 12:
              res = _context15.sent;
              getServices();
              _context15.next = 21;
              break;

            case 16:
              specialistDone = ["RC", "RA", "CA"].includes(evalStatus);

              if (specialistDone) {
                _message = "".concat(activeTab, " enviada a facilitador");
                getSectionIcon();
              } else if (["IE", "AC", "RP", "RCA"].includes(evalStatus)) {
                _message = "Evaluación enviada";
                getSectionIcon();
              }

              _context15.next = 20;
              return _axios.default.put("".concat(process.env.REACT_APP_SEND_EVAL), data, {
                headers: {
                  Authorization: token
                }
              });

            case 20:
              res = _context15.sent;

            case 21:
              if (!(res.data.statusCode === 200)) {
                _context15.next = 34;
                break;
              }

              _JSON$parse5 = JSON.parse(res.data.body), newStatus = _JSON$parse5.newStatus, newOrderStatus = _JSON$parse5.newOrderStatus, newArticleStatus = _JSON$parse5.newArticleStatus;
              messageToChat = (0, _utils.createMessage)(product.retailers, activeRetailer.id, evalStatus, newStatus, activeTab);
              _data = {
                paramsBody: {
                  id: product.article.id_article,
                  version: version,
                  items: [{
                    type: "status",
                    value: messageToChat
                  }],
                  retailerId: activeRetailer.id,
                  status: product.status
                },
                paramsHeader: {
                  Authorization: token
                }
              };
              _context15.next = 27;
              return (0, _utils.sendMessage)(_data);

            case 27:
              if (newOrderStatus) productTemp.status = newArticleStatus[articleId];
              productTemp["".concat(concept, "_status")] = newStatus;
              _context15.next = 31;
              return loadData();

            case 31:
              if (_message) setMessage(_message);
              sessionStorage.setItem("productSelected", JSON.stringify(productTemp));
              setProduct(productTemp);

            case 34:
              _context15.next = 39;
              break;

            case 36:
              _context15.prev = 36;
              _context15.t0 = _context15["catch"](1);
              console.log(_context15.t0);

            case 39:
              setLoading(false);

            case 40:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, null, [[1, 36]]);
    }));

    return function sendToFacilitator(_x5) {
      return _ref19.apply(this, arguments);
    };
  }();

  var userAssigned = function userAssigned(tab, rol) {
    var concept = getConcept(activeTab);
    var allowedRoles = [1, 4, 5, 6, 7, 8];
    var validUser = allowedRoles.includes(user === null || user === void 0 ? void 0 : user.id_role);

    if (!rol) {
      switch (user.id_role) {
        case 4:
        case 5:
          rol = "facilitator";
          break;

        case 7:
        case 8:
          rol = "especialist";
          break;
      }
    }

    return user.id_role === 1 || product.article["id_".concat(concept, "_").concat(rol)] === user.id_user && validUser;
  };

  var auditorAssigned = function auditorAssigned() {
    return (product === null || product === void 0 ? void 0 : product.article["id_auditor"]) === user.id_user;
  };

  var createComment = /*#__PURE__*/function () {
    var _ref20 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16(e, body, tab) {
      var _product$article16;

      var concept, data;
      return _regenerator.default.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              concept = "";
              _context16.t0 = activeTab;
              _context16.next = _context16.t0 === "Ficha técnica" ? 4 : _context16.t0 === "Imágenes" ? 6 : 8;
              break;

            case 4:
              concept = "datasheet";
              return _context16.abrupt("break", 10);

            case 6:
              concept = "images";
              return _context16.abrupt("break", 10);

            case 8:
              concept = "description";
              return _context16.abrupt("break", 10);

            case 10:
              data = {
                articleId: product === null || product === void 0 ? void 0 : (_product$article16 = product.article) === null || _product$article16 === void 0 ? void 0 : _product$article16.id_article,
                orderId: product === null || product === void 0 ? void 0 : product.orderId,
                message: body === null || body === void 0 ? void 0 : body.replace(/<.*?\/?>/gm, ""),
                concept: concept,
                version: version
              };
              _context16.next = 13;
              return _axios.default.post("".concat(process.env.REACT_APP_COMMENTS_ENDPOINT), data, {
                headers: {
                  Authorization: token
                }
              });

            case 13:
              _context16.next = 15;
              return getComments(tab);

            case 15:
              setMessage("");
              setComponentsArray([]);

            case 17:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    }));

    return function createComment(_x6, _x7, _x8) {
      return _ref20.apply(this, arguments);
    };
  }();

  var getRequired = function getRequired(services) {
    try {
      var _services$2, _services$2$retailerM, _services$3, _services$3$inputs;

      var objetcTemp = {};
      var datasheetServicesArray = Object.values(services[0]);
      var dsInputs = datasheetServicesArray.pop();
      var descriptionsServicesArray = services[1];
      var dsInputsRequired = [];
      var desInputsRequired = 0;
      datasheetServicesArray === null || datasheetServicesArray === void 0 ? void 0 : datasheetServicesArray.forEach(function (datasheet) {
        var _servicesData$filter = servicesData === null || servicesData === void 0 ? void 0 : servicesData.filter(function (srv) {
          return srv.id_retailer === datasheet.retailer.id && srv.service === getConcept(activeTab);
        }),
            _servicesData$filter2 = (0, _slicedToArray2.default)(_servicesData$filter, 1),
            requested = _servicesData$filter2[0];

        requested && (datasheet === null || datasheet === void 0 ? void 0 : datasheet.data) && Object.values(datasheet === null || datasheet === void 0 ? void 0 : datasheet.data).forEach(function (dataGroup) {
          return dsInputsRequired.push.apply(dsInputsRequired, (0, _toConsumableArray2.default)(dataGroup.inputs.filter(function (input) {
            return dsInputs[input].required && (dsInputs[input].value === undefined || !dsInputs[input].value);
          })));
        });
      });
      objetcTemp["Ficha técnica"] = dsInputsRequired.length;
      var regex = /(<\/?p>)|(<\/?strong>)|(<br>)/gm;
      descriptionsServicesArray.forEach(function (description) {
        var _servicesData$filter3 = servicesData.filter(function (srv) {
          return srv.id_retailer === description.id && srv.service === getConcept(activeTab);
        }),
            _servicesData$filter4 = (0, _slicedToArray2.default)(_servicesData$filter3, 1),
            requested = _servicesData$filter4[0];

        if (requested) {
          description.inputs.forEach(function (input) {
            var _input$value;

            if (input.required && (!input.value || ((_input$value = input.value) === null || _input$value === void 0 ? void 0 : _input$value.replace(regex, "")) === "")) {
              desInputsRequired++;
            }
          });
        }
      });
      objetcTemp["Descripción"] = desInputsRequired;
      var retailersRequested = [];
      (_services$2 = services[2]) === null || _services$2 === void 0 ? void 0 : (_services$2$retailerM = _services$2.retailerMandatories) === null || _services$2$retailerM === void 0 ? void 0 : _services$2$retailerM.forEach(function (retMan) {
        return retMan.forEach(function (rm) {
          return retailersRequested.push(rm);
        });
      });
      var requiredImages = (_services$3 = services[2]) === null || _services$3 === void 0 ? void 0 : (_services$3$inputs = _services$3.inputs) === null || _services$3$inputs === void 0 ? void 0 : _services$3$inputs.filter(function (e) {
        return e.required === 1 && retailersRequested.filter(function (ret) {
          return ret.id_image === e.id && servicesData.filter(function (srv) {
            return srv.id_retailer === ret.id_retailer;
          }).length > 0;
        }).length > 0;
      });
      var requiredCounter = 0;
      requiredImages === null || requiredImages === void 0 ? void 0 : requiredImages.forEach(function (req) {
        return services[2].values.filter(function (img) {
          return img.image_id === req.id;
        }).length === 0 && requiredCounter++;
      });
      objetcTemp["Imágenes"] = requiredCounter;
      setRequiredNull(objetcTemp);
    } catch (error) {
      console.log(error);
    }
  };

  (0, _react.useEffect)(function () {
    setComment(comments[activeTab]);
  }, [activeTab]);

  var commentRevised = /*#__PURE__*/function () {
    var _ref21 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17() {
      var data;
      return _regenerator.default.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              data = {
                commentId: comment.id
              };
              _context17.next = 3;
              return _axios.default.put("".concat(process.env.REACT_APP_COMMENTS_ENDPOINT), data, {
                headers: {
                  Authorization: sessionStorage.getItem("jwt")
                }
              });

            case 3:
              setCrossComment(false);
              _context17.next = 6;
              return getComments();

            case 6:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }));

    return function commentRevised() {
      return _ref21.apply(this, arguments);
    };
  }();

  var setAssignation = /*#__PURE__*/function () {
    var _ref22 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee18(assignationType, assignationId) {
      var _product$article17;

      var concept, productTemp, data;
      return _regenerator.default.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              concept = "";
              _context18.t0 = activeTab;
              _context18.next = _context18.t0 === "Ficha técnica" ? 4 : _context18.t0 === "Imágenes" ? 6 : 8;
              break;

            case 4:
              concept = "datasheet";
              return _context18.abrupt("break", 10);

            case 6:
              concept = "images";
              return _context18.abrupt("break", 10);

            case 8:
              concept = "description";
              return _context18.abrupt("break", 10);

            case 10:
              productTemp = product;
              productTemp.article["id_".concat(concept, "_").concat(assignationType)] = assignationId;
              data = {
                articleList: [{
                  orderId: product.orderId,
                  articleId: product === null || product === void 0 ? void 0 : (_product$article17 = product.article) === null || _product$article17 === void 0 ? void 0 : _product$article17.id_article
                }],
                concept: concept,
                userId: assignationId
              };
              _context18.next = 15;
              return (0, _axios.default)({
                method: "post",
                url: process.env.REACT_APP_ASSIGNATIONS_ENDPOINT,
                data: data,
                headers: {
                  Authorization: token
                }
              });

            case 15:
              loadAssignations(productTemp);
              sessionStorage.setItem("productSelected", JSON.stringify(productTemp));

            case 17:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18);
    }));

    return function setAssignation(_x9, _x10) {
      return _ref22.apply(this, arguments);
    };
  }();

  var downloadImages = function downloadImages() {
    var _images$values4;

    selectedImages.length > 0 ? selectedImages.forEach(function (e) {
      if (e.id) {
        (0, _fileSaver.saveAs)("https://".concat(process.env.REACT_APP_IMAGES_BUCKET, ".s3.amazonaws.com/").concat(e.srcDB), "".concat(product.article.upc, "_").concat(e.name, ".").concat(e.ext));
      }
    }) : images === null || images === void 0 ? void 0 : (_images$values4 = images.values) === null || _images$values4 === void 0 ? void 0 : _images$values4.forEach(function (e) {
      if (e.id) {
        (0, _fileSaver.saveAs)("https://".concat(process.env.REACT_APP_IMAGES_BUCKET, ".s3.amazonaws.com/").concat(e.srcDB), "".concat(product.article.upc, "_").concat(e.name, ".").concat(e.ext));
      }
    });
  };

  var deleteImages = function deleteImages() {
    setLoading(true);
    var values = images.values;
    var imgsInBack = [];
    selectedImages.forEach(function (selectedImg) {
      if (selectedImg.id) imgsInBack.push(selectedImg);
    });
    var imgsLeft = values.filter(function (value) {
      return selectedImages.indexOf(value) === -1;
    });

    if (imgsInBack.length > 0) {
      var data = {
        articleId: product.article.id_article,
        deleteImages: imgsInBack,
        orderId: product.orderId
      };

      try {
        _axios.default.put("".concat(process.env.REACT_APP_ARTICLE_DATA_ENDPOINT, "?image=true&version=").concat(version), data, {
          headers: {
            Authorization: token
          }
        });
      } catch (err) {
        console.log(err);
      }
    }

    setImages({
      action: "deleteImage",
      selectedImages: selectedImages
    });
    getRequired([services[0], services[1], (0, _objectSpread2.default)((0, _objectSpread2.default)({}, services[2]), {}, {
      values: imgsLeft
    })]);
    setTimeout(function () {
      setLoading(false);
    }, 500);
    setMessage("");
    setComponentsArray([]);
  };

  var askToDeleteImages = function askToDeleteImages() {
    if (selectedImages.length > 0) {
      setMessage("¿Está seguro de eliminar las imágenes seleccionadas?");
      setComponentsArray([/*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
        text: "¿Está seguro de eliminar las imágenes seleccionadas?",
        headerType: "retailer-name-header",
        color: "white"
      }, "1"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
        buttonType: "general-white-button",
        label: "Cancelar",
        onClick: function onClick() {
          return setMessage("");
        }
      }, "2"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
        buttonType: "general-button-default",
        label: "Aceptar",
        onClick: function onClick() {
          setMessage("");
          deleteImages();
        }
      }, "3")]);
    }
  };

  var getRetailerStatus = function getRetailerStatus(servicesData, tab) {
    var arr = servicesData === null || servicesData === void 0 ? void 0 : servicesData.slice();
    var concept = getConcept(tab);
    var retailerService = {};

    var _arr$filter = arr === null || arr === void 0 ? void 0 : arr.filter(function (service) {
      return service.id_retailer === (activeRetailer === null || activeRetailer === void 0 ? void 0 : activeRetailer.id) && service.service === concept;
    });

    var _arr$filter2 = (0, _slicedToArray2.default)(_arr$filter, 1);

    retailerService = _arr$filter2[0];
    return retailerService ? retailerService.status : "NS";
  };

  (0, _react.useEffect)(function () {
    var status = getRetailerStatus(servicesData, activeTab);
    setRetailerStatus(status);
  }, [activeTab, servicesData, activeRetailer]);
  (0, _react.useEffect)(function () {
    services.length > 0 && getRequired(services);
  }, [services, servicesData, activeTab]);
  (0, _react.useEffect)(function () {
    setSaving(loading);
  }, [loading]);

  var validateAll = /*#__PURE__*/function () {
    var _ref23 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee19(result) {
      var evaluationArray, conceptArray, messages, productTemp, messagesResponse;
      return _regenerator.default.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.prev = 0;
              setLoading(true);
              evaluationArray = [];
              conceptArray = [];
              _context19.t0 = user.id_role;
              _context19.next = _context19.t0 === 4 ? 7 : _context19.t0 === 5 ? 9 : 11;
              break;

            case 7:
              conceptArray = ["description", "datasheet"];
              return _context19.abrupt("break", 13);

            case 9:
              conceptArray = ["images"];
              return _context19.abrupt("break", 13);

            case 11:
              conceptArray = ["description", "datasheet", "images"];
              return _context19.abrupt("break", 13);

            case 13:
              messages = [];
              servicesData === null || servicesData === void 0 ? void 0 : servicesData.forEach(function (ret) {
                if (conceptArray.includes(ret.service)) {
                  var _product$id_order;

                  var data = {
                    articleId: product.article.id_article,
                    orderId: (_product$id_order = product.id_order) !== null && _product$id_order !== void 0 ? _product$id_order : product.orderId,
                    concept: ret.service,
                    result: result,
                    evalStatus: ret.status,
                    retailerId: ret.id_retailer
                  };
                  evaluationArray.push(_axios.default.put("".concat(process.env.REACT_APP_EVALUATION_ENDPOINT), data, {
                    headers: {
                      Authorization: token
                    }
                  }));
                }
              });
              _context19.next = 17;
              return Promise.all(evaluationArray);

            case 17:
              productTemp = product;
              productTemp.status = "".concat(result, "A");
              productTemp.datasheet_status = productTemp.datasheet_status === "NS" ? "NS" : "".concat(result, "A");
              productTemp.description_status = productTemp.description_status === "NS" ? "NS" : "".concat(result, "A");
              productTemp.images_status = productTemp.images_status === "NS" ? "NS" : "".concat(result, "A");
              sessionStorage.setItem("productSelected", JSON.stringify(productTemp));
              setProduct(productTemp);
              _context19.next = 26;
              return Promise.all(messages);

            case 26:
              messagesResponse = _context19.sent;
              _context19.next = 29;
              return loadData();

            case 29:
              _context19.next = 34;
              break;

            case 31:
              _context19.prev = 31;
              _context19.t1 = _context19["catch"](0);
              console.log(_context19.t1);

            case 34:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19, null, [[0, 31]]);
    }));

    return function validateAll(_x11) {
      return _ref23.apply(this, arguments);
    };
  }();

  var getObservation = /*#__PURE__*/function () {
    var _ref24 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee20() {
      var response, parseData;
      return _regenerator.default.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return _axios.default.get("".concat(process.env.REACT_APP_READ_OBSERVATION, "?articleId=").concat(product.article.id_article, "&orderId=").concat(product === null || product === void 0 ? void 0 : product.orderId), {
                headers: {
                  Authorization: sessionStorage.getItem("jwt")
                }
              });

            case 2:
              response = _context20.sent;
              parseData = JSON.parse(response.data.body).data[0];
              setObservation(parseData.observations);

            case 5:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20);
    }));

    return function getObservation() {
      return _ref24.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    getObservation();
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    headerTop: headerTop,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_HeaderTop.HeaderTop, {
      setHeaderTop: setHeaderTop,
      auditableVersion: auditableVersion,
      setCompare: setCompare,
      isAuditor: [1, 6].includes(user.id_role),
      withChat: location === null || location === void 0 ? void 0 : (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.withChat,
      chatType: location === null || location === void 0 ? void 0 : (_location$state2 = location.state) === null || _location$state2 === void 0 ? void 0 : _location$state2.chatType,
      productSelected: product,
      token: token,
      activeRetailer: activeRetailer
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "data-container",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "image-data-panel",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ImagePreviewer.ImagePreviewer, {
          activeImage: images !== null && images !== void 0 && images.values ? images === null || images === void 0 ? void 0 : images.values[activeImage] : {},
          imagesArray: images,
          setActiveImage: setActiveImage,
          setShowModal: setShowModal
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImageDataTable.ImageDataTable, {
          lists: images,
          activeImage: images !== null && images !== void 0 && images.values ? images === null || images === void 0 ? void 0 : images.values[activeImage] : {},
          retailerSelected: activeRetailer === null || activeRetailer === void 0 ? void 0 : activeRetailer.id,
          setImages: setImages,
          assignationsImages: assig["Imágenes"],
          imagesStatus: product === null || product === void 0 ? void 0 : product.images_status,
          setAssignation: setAssignation,
          isRetailer: isRetailer,
          onClickSave: function onClickSave() {
            var _product$services;

            return (product === null || product === void 0 ? void 0 : (_product$services = product.services) === null || _product$services === void 0 ? void 0 : _product$services.images) === 1 && updateImages();
          },
          showSaveButton: auditorAssigned() || userAssigned(),
          setShowVersionSelector: setShowVersionSelector,
          version: version,
          shotThd: shotThd
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "product-information",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FullProductNameHeader.FullProductNameHeader, {
          headerData: product,
          productObservation: observation,
          percent: activePercentage,
          activeRetailer: activeRetailer,
          servicesData: servicesData,
          setActiveRetailer: setActiveRetailer,
          sendToFacilitator: sendToFacilitator,
          approve: function approve() {
            sendToFacilitator("A");
          },
          reject: function reject() {
            setShowRejectModal(true);
          },
          showApproveRejectAll: approveRejectAllButtons() && (auditorAssigned() || userAssigned()),
          showValidationButtons: approveRejectButtons() && (auditorAssigned() || userAssigned()),
          approveAll: function approveAll() {
            return validateAll("A");
          },
          rejectAll: function rejectAll() {
            setShowRejectModal(true);
            setValRejAll(true);
          },
          isObservationVisible: isObservationVisible,
          toggleObservation: toggleObservation // handleClickOutside={handleClickOutside}
          ,
          hideObservation: hideObservation
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FullTabsMenu.FullTabsMenu, {
          tabsSections: tabsSections,
          status: retailerStatus,
          activeTab: activeTab,
          setActiveTab: setActiveTab,
          setImageLayout: setImageLayout,
          downloadImages: downloadImages,
          askToDeleteImages: askToDeleteImages,
          assig: assig[activeTab],
          setAssignation: setAssignation,
          isRetailer: isRetailer,
          showSaveButton: auditorAssigned() || userAssigned(),
          version: version,
          desc: desc,
          setDesc: setDesc,
          fich: fich,
          setFich: setFich,
          imag: imag,
          setImag: setImag,
          updatedDescriptions: updatedDescriptions,
          setUpdatedDescriptions: setUpdatedDescriptions,
          updatedDatasheets: updatedDatasheets,
          setUpdatedDatasheets: setUpdatedDatasheets,
          images: images,
          setImages: setImages,
          selectedImages: selectedImages,
          setSelectedImages: setSelectedImages,
          setShowVersionSelector: setShowVersionSelector,
          onClickSave: function onClickSave() {
            switch (activeTab) {
              case "Descripción":
                !saving && (product === null || product === void 0 ? void 0 : product.description_status) !== "NS" && saveDescriptions();
                break;

              case "Ficha técnica":
                !saving && (product === null || product === void 0 ? void 0 : product.datasheet_status) !== "NS" && saveDatasheets();
                break;

              case "Imágenes":
                !saving && (product === null || product === void 0 ? void 0 : product.images_status) !== "NS" && updateImages();
                break;

              default:
                break;
            }
          },
          canAssign: ![7, 8].includes(user.id_role)
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "services-information-container " + (imageLayout && activeTab === "Imágenes" ? "image-services" : ""),
          children: loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {}) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [!imageLayout && activeTab === "Imágenes" && (product === null || product === void 0 ? void 0 : (_product$services2 = product.services) === null || _product$services2 === void 0 ? void 0 : _product$services2.images) === 1 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_GalleryHeader.GalleryHeader, {
              setSelectedImages: setSelectedImages,
              checkAll: checkAll,
              setCheckAll: setCheckAll,
              shotThd: shotThd
            }), activeTab === "Ficha técnica" && ((product === null || product === void 0 ? void 0 : product.datasheet_status) !== "NS" ? (_datasheets$ = datasheets[0]) === null || _datasheets$ === void 0 ? void 0 : (_datasheets$$data = _datasheets$.data) === null || _datasheets$$data === void 0 ? void 0 : _datasheets$$data.map(function (dataGroup, index) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputGroup.InputGroup, {
                articleId: product.article.id_article,
                version: version,
                activeSection: activeTab,
                inputGroup: dataGroup,
                dataInputs: datasheets[1],
                auditInputs: auditDatasheets[1],
                updatedDatasheets: updatedDatasheets,
                setUpdatedDatasheets: setUpdatedDatasheets,
                compare: compare
              }, index + "-" + activeRetailer.name);
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
              text: "No cuentas con este servicio",
              headerType: "input-name-header"
            })), activeTab === "Descripción" && ((product === null || product === void 0 ? void 0 : product.description_status) !== "NS" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputGroup.InputGroup, {
              activeSection: activeTab,
              inputGroup: descriptions[0],
              auditInputGroup: auditDescriptions[0],
              updatedDescriptions: updatedDescriptions,
              setUpdatedDescriptions: setUpdatedDescriptions,
              articleId: product === null || product === void 0 ? void 0 : (_product$article18 = product.article) === null || _product$article18 === void 0 ? void 0 : _product$article18.id_article,
              version: version,
              dinamicHeight: true,
              compare: compare
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
              text: "No cuentas con este servicio",
              headerType: "input-name-header"
            })), activeTab === "Imágenes" && ((product === null || product === void 0 ? void 0 : product.images_status) !== "NS" ? /*#__PURE__*/(0, _jsxRuntime.jsx)("section", {
              className: "container",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, getRootProps({
                className: "dropzone"
              })), {}, {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", (0, _objectSpread2.default)({}, getInputProps())), /*#__PURE__*/(0, _jsxRuntime.jsx)("aside", {
                  children: thumbs()
                })]
              }))
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
              text: "No cuentas con este servicio",
              headerType: "input-name-header"
            }))]
          })
        }), (userAssigned(activeTab) || auditorAssigned()) && product["".concat(getConcept(activeTab), "_status")] !== "NS" && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "commentary-box",
          children: [!comment ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "commentary",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_index.TagAndInput, {
              label: "Caja de Comentario",
              inputType: "textarea",
              inputCols: 80,
              inputRows: 4,
              inputId: "commentary-box",
              index: 0
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "buttons-box",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
                buttonType: "general-transparent-button",
                label: "Enviar comentario",
                onClick: handleCommentSubmit
              })
            })]
          }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "feedback-box",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Commentary.Commentary, {
              comment: comment === null || comment === void 0 ? void 0 : (_comment$message = comment.message) === null || _comment$message === void 0 ? void 0 : _comment$message.replace(/<.*?\/?>/gm, ""),
              reviewed: crossComment
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
              buttonType: "circular-button accept-button",
              onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee21() {
                return _regenerator.default.wrap(function _callee21$(_context21) {
                  while (1) {
                    switch (_context21.prev = _context21.next) {
                      case 0:
                        setCrossComment(true);
                        commentRevised();

                      case 2:
                      case "end":
                        return _context21.stop();
                    }
                  }
                }, _callee21);
              }))
            })]
          }), [7, 8].includes(user.id_role) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
            buttonType: evaluationFinished(user.id_role, activeTab, statusArray) && requiredNull[activeTab] === 0 ? "general-green-button" : "general-button-disabled",
            label: "Enviar evaluación",
            onClick: function onClick() {
              return sendToFacilitator();
            }
          })]
        })]
      })]
    }), showModal && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductImageModal.ProductImageModal, {
      images: images,
      setShowModal: setShowModal,
      sendToFacilitator: sendToFacilitator,
      approveRejectButtons: approveRejectButtons()
    }), message.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_GenericModal.GenericModal, {
      buttonType: componentsArray.length > 0 && "delete-product",
      componentsArray: componentsArray.length > 0 ? componentsArray : [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: _genericModalCheck.default,
        alt: "success icon"
      }, "1"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
        headerType: "retailer-name-header",
        text: message,
        color: "white"
      }, "2")],
      onClick: function onClick() {
        return setMessage("");
      }
    }), showVersionSelector && /*#__PURE__*/(0, _jsxRuntime.jsx)(_VersionSelector.VersionSelector, {
      modalId: "version-selector",
      articleId: product.article.id_article,
      setVersion: setVersion,
      companyName: product.article.company_name,
      currentVersion: version,
      setShowVersionSelector: setShowVersionSelector,
      jwt: token
    }), showRejectModal && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal, {
      title: "Agregar mensaje de rechazo para ".concat(activeTab === null || activeTab === void 0 ? void 0 : activeTab.toLowerCase()),
      show: showRejectModal,
      customComponent: /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.TagAndInput, {
        inputType: "textarea",
        inputId: "modal-message-box",
        index: 0,
        color: "white"
      }),
      buttons: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
        type: "white",
        label: "Cancelar",
        size: 12,
        onClick: function onClick() {
          setShowRejectModal(false);
        }
      }, "btn-Cancelar"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
        type: "pink",
        label: "Aceptar",
        size: 12,
        onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee22() {
          var body, messages;
          return _regenerator.default.wrap(function _callee22$(_context22) {
            while (1) {
              switch (_context22.prev = _context22.next) {
                case 0:
                  body = document.querySelector("#modal-message-box .ql-container .ql-editor > p").innerHTML;
                  messages = [{
                    type: "message",
                    value: body === null || body === void 0 ? void 0 : body.replace(/<.*?\/?>/gm, "")
                  }];
                  _context22.next = 4;
                  return createComment(messages, activeRetailer.id);

                case 4:
                  valRejAll ? validateAll("R") : sendToFacilitator("R");
                  setMessage("Rechazado");
                  setShowRejectModal(false);

                case 7:
                case "end":
                  return _context22.stop();
              }
            }
          }, _callee22);
        }))
      }, "btn-Aceptar")]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal, {
      className: "container-modalAlert",
      show: modalAlert.show,
      title: modalAlert.title,
      message: modalAlert.message,
      icon: "info",
      onClickBtnDefault: function onClickBtnDefault(event) {
        setModalAlert(function (prev) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, prev), {}, {
            show: false,
            errorInputMessage: false
          });
        });
      }
    })]
  });
};

exports.RetailerProductEdition = RetailerProductEdition;